import React, { useState } from "react";
import Table from "./Table";
import { useQuery, useMutation } from "@tanstack/react-query";
import { toast, Toaster } from "sonner";
import httpCommon from "../../../../http-common";
import { queryClient } from "../../../../index";

const Provider = () => {
  const [open, setOpen] = useState(false);

  const fetchData = async () => {
    const res = await httpCommon.get("/property-data");
    return res.data?.data || [];
  };

  const { data = [], isLoading, isError } = useQuery({
    queryKey: ["assetPropertyData"],
    queryFn: fetchData,
  });

  const deleteRow = async (id) => {
    const res = await httpCommon.delete(`/property-data/${id}`);
    return res.data;
  };

  const mutation = useMutation({
    mutationFn: deleteRow,
    onSuccess: () => {
      toast.success("Deleted successfully");
      queryClient.invalidateQueries({ queryKey: ["assetPropertyData"] });
      setOpen(false);
    },
    onError: () => toast.error("Delete failed"),
  });

  if (isLoading) return "Loading...";
  if (isError) return "Failed to load";

  return (
    <>
      <Table
        data={data}
        open={open}
        setOpen={setOpen}
        mutation={mutation}
      />
      <Toaster richColors />
    </>
  );
};

export default Provider;
